export default "assets/images/icons/mail-9c218f90.svg";